import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["action", "actionId", "actionMetadata", "flowObjectTypeId", "getActionOutputsForTargetActionById", "getHeaderTitle", "headerIcon", "titleUseTheme"];
import ExtensionActionDetail from 'automation-ui-action-features/actions/extension/ExtensionActionDetail';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import { jsx as _jsx } from "react/jsx-runtime";
const ExtensionActionCard = _ref => {
  let {
      action,
      actionId,
      actionMetadata,
      flowObjectTypeId,
      getActionOutputsForTargetActionById,
      getHeaderTitle,
      headerIcon,
      titleUseTheme
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, restProps, {
    headerIcon: headerIcon,
    headerTitle: getHeaderTitle({
      actionId: actionId
    }),
    content: /*#__PURE__*/_jsx(ExtensionActionDetail, {
      action: action,
      actionMetadata: actionMetadata,
      getActionOutputsForTargetActionById: getActionOutputsForTargetActionById,
      getActionLabelById: getHeaderTitle,
      flowObjectTypeId: flowObjectTypeId
    }),
    titleUseTheme: titleUseTheme
  }));
};
export default ExtensionActionCard;